/* Svensk katalog for locale-invoice-payment-actions-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'inv.pay.undoPayment': 'Ångra betalning',
  'inv.pay.undoRefund': 'Ångra återbetalning',
  'inv.pay.undoPaymentTitle': 'Ångra registrerad betalning?',
  'inv.pay.undoRefundTitle': 'Ångra registrerad återbetalning?',
  'inv.pay.undoPaymentBody': 'Betalningen återförs och fakturan öppnas igen med motsvarande restbelopp. Den ursprungliga bokningen behålls i historiken.',
  'inv.pay.undoRefundBody': 'Återbetalningen återförs och kundens tillgodobelopp öppnas igen. Den ursprungliga bokningen behålls i historiken.',
  'inv.toast.paymentReversed': 'Betalningen har återförts',
  'inv.toast.refundReversed': 'Återbetalningen har återförts',
  'inv.err.paymentReverseFailed': 'Det gick inte att återföra betalningen.',
  'inv.err.refundReverseFailed': 'Det gick inte att återföra återbetalningen.',
});
